import { Query, WorkflowObjectState } from 'olympe';
import { registerDataGridRenderer } from '../../shared/datagrid/DataGridRegistry.jsx';
import * as React from 'react';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import { red, blue, green, grey, lightBlue,deepPurple } from '@mui/material/colors';
import { BCP_WORKFLOW_BUSINESS_NAMES } from '../../../common/section_bcp/BcpWorkflowAuthorizations';
import { createTheme, ThemeProvider } from '@mui/material/styles';

/**
 * WORKFLOW_CHIP
 * Render values BCP state
 */
registerDataGridRenderer({
    name: 'WORKFLOW_CHIP',
    render: (_values, _options, object, $) => {
        return <WorkFlowChip object={object} $={$} />;
    }
});

/**
 * Render values BCP state
 * @param {!BrickContext} $
 * @param {BCP} object
 */
const WorkFlowChip = ({ $, object }) => {
    const [state, setState] = React.useState('');

    React.useEffect(() => {
        const worflowObject = $.get('Workflows').get(object.getTag());
        if (worflowObject) {
            //  get workflow state value from 'workflows' context value.
            const workflowState = worflowObject.get(WorkflowObjectState.stateProp);
            setState(workflowState);
        }
        else {
            // if the workflow value is undefined, this function fetches the required workflow object
            const getWorkflowState = async () => {
                const workflowQuery = Query.from(object).follow(WorkflowObjectState.currentObjectRel.getInverse()).andReturn();
                const workflowState = (await workflowQuery.execute()).toArray()[0].get(WorkflowObjectState.stateProp);
                setState(workflowState);
            }
            getWorkflowState().catch((e) => {
                setState('Invalid State');
                console.error(`Workflow chip component: error while fetching workflow state: ${e}`);
            });
        }

    }, [object]);

    const businessName = BCP_WORKFLOW_BUSINESS_NAMES[state];
    const label = Object.keys(STATUS_COLOR).includes(state) ? state : 'Default';
    return state
        ? (
            <ThemeProvider theme={chipTheme}>
                <Chip label={businessName} color={label} variant='outlined' sx={{ margin: '0 auto' }} />
            </ThemeProvider>) : (<CircularProgress sx={{ margin: '0 auto' }} />);
};

const chipTheme = createTheme({
    palette: {
        'Alternative VS suggestion by BP': {
            main: lightBlue[200],
            contrastText: lightBlue[200],
        },
        'Alternative VS check by PM': {
            main: blue[500],
            contrastText: blue[500]
        },
        'Waiting on completion criteria': {
            main: blue[900],
            contrastText: blue[900]
        },
        'Completed': {
            main: green[800],
            contrastText: green[800]
        },
        'Rejected': {
            main: red[900],
            contrastText: red[900]
        },
        'CTAG acceptance': {
            main: deepPurple[800],
            contrastText: deepPurple[800]
        },
        'SQA_QA factory acceptance 1': {
            main: deepPurple[800],
            contrastText: deepPurple[800]
        },
        'SQA_QA factory acceptance 2': {
            main: deepPurple[800],
            contrastText: deepPurple[800]
        },
        'Default': {
            main: grey[800],
            contrastText: grey[800]
        }
    }
});

/**
  Workflow Chip colors.
 See {https://mui.com/material-ui/customization/color/#color-palette}
*/
const STATUS_COLOR = {
    'Alternative VS suggestion by BP': lightBlue[200],
    'Alternative VS check by PM': blue[500],
    'Waiting on completion criteria': blue[900],
    'Completed': green[800],
    'Rejected': red[900],
    'CTAG acceptance': deepPurple[800],
    'SQA_QA factory acceptance 1': deepPurple[800],
    'SQA_QA factory acceptance 2':deepPurple[800],
    'Default': grey[800]
};
